/* eslint-disable */
/**
 * @note This is an auto-generated file. Do not modify it directly.
 * @see https://devdocs.transfix.io/graphql
 *
 * If you need to update the hooks or definitions in this file:
 * 1. Edit the .graphql file in this directory with the same name
 * 2. Run `npm run generate:graphql:mp` in the terminal
 */

import * as Types from '../../../../../types/graphqlTypes'

import { gql } from '@apollo/client'
import { CarrierProfileFragmentDoc } from './CarrierProfileFragment'
import * as Apollo from '@apollo/client'
const defaultOptions = {}
export type ICarrierProfileQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']
}>

export type ICarrierProfileQuery = { __typename?: 'Query' } & {
  carrierApplication?: Types.Maybe<
    { __typename?: 'CarrierApplication' } & Pick<Types.ICarrierApplication, 'id'> & {
        carrierProfile?: Types.Maybe<
          { __typename?: 'CarrierProfile' } & Pick<
            Types.ICarrierProfile,
            'excludedCommodities' | 'endorsements'
          > & {
              certifications: Array<
                { __typename?: 'CarrierCertification' } & Pick<
                  Types.ICarrierCertification,
                  'certificationId' | 'code' | 'issuingOrganization' | 'isVerified' | 'renewalDate'
                >
              >
              dedicatedLaneRatePreference?: Types.Maybe<
                { __typename?: 'CarrierDedicatedLaneRatePreference' } & Pick<
                  Types.ICarrierDedicatedLaneRatePreference,
                  'id' | 'isInterestedInDedicatedLanes' | 'minimumRatePerMile'
                >
              >
              loadingCapability?: Types.Maybe<
                { __typename?: 'CarrierLoadingCapability' } & Pick<
                  Types.ICarrierLoadingCapability,
                  'id' | 'isLiveCapable' | 'isDropCapable' | 'isHeavyLoadCapable' | 'isPowerOnly'
                >
              >
              rateTypePreference?: Types.Maybe<
                { __typename?: 'CarrierRateTypePreference' } & Pick<
                  Types.ICarrierRateTypePreference,
                  'id' | 'allowsAllIn' | 'allowsDayRate' | 'hasLineHaulFuelSurcharge'
                >
              >
              smartWayRegistration?: Types.Maybe<
                { __typename?: 'CarrierSmartWayRegistration' } & Pick<
                  Types.ICarrierSmartWayRegistration,
                  'id' | 'isRegistered' | 'renewalDate'
                >
              >
              equipmentCapability?: Types.Maybe<
                { __typename?: 'CarrierEquipmentCapability' } & Pick<
                  Types.ICarrierEquipmentCapability,
                  | 'id'
                  | 'isDryVanCapable'
                  | 'isFlatbedCapable'
                  | 'isReeferCapable'
                  | 'isTrailerOnly'
                  | 'powerUnitCount'
                  | 'trailerCount'
                >
              >
              freightCapability?: Types.Maybe<
                { __typename?: 'CarrierFreightCapability' } & Pick<
                  Types.ICarrierFreightCapability,
                  | 'id'
                  | 'isDrayageCapable'
                  | 'isFtlCapable'
                  | 'isIntermodalCapable'
                  | 'isLtlCapable'
                >
              >
            }
        >
      }
  >
}

export const CarrierProfileDocument = gql`
  query CarrierProfile($id: ID!) {
    carrierApplication(id: $id) {
      id
      ...CarrierProfile
    }
  }
  ${CarrierProfileFragmentDoc}
`

/**
 * __useCarrierProfileQuery__
 *
 * To run a query within a React component, call `useCarrierProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useCarrierProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCarrierProfileQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCarrierProfileQuery(
  baseOptions: Apollo.QueryHookOptions<ICarrierProfileQuery, ICarrierProfileQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<ICarrierProfileQuery, ICarrierProfileQueryVariables>(
    CarrierProfileDocument,
    options
  )
}
export function useCarrierProfileLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ICarrierProfileQuery, ICarrierProfileQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<ICarrierProfileQuery, ICarrierProfileQueryVariables>(
    CarrierProfileDocument,
    options
  )
}
export type CarrierProfileQueryHookResult = ReturnType<typeof useCarrierProfileQuery>
export type CarrierProfileLazyQueryHookResult = ReturnType<typeof useCarrierProfileLazyQuery>
export type CarrierProfileQueryResult = Apollo.QueryResult<
  ICarrierProfileQuery,
  ICarrierProfileQueryVariables
>
